module.exports = __webpack_public_path__ + "img/Dantam Makeover 07.412d050a.jpg";